import type { Category, PriceRange, SortOption } from '../model/types'

export const CATEGORIES: Category[] = [
  { slug: 'xe-may-dien', label: 'Xe máy điện' },
  { slug: 'xe-dap-dien', label: 'Xe đạp điện' },
  { slug: 'xe-tay-ga-dien', label: 'Xe tay ga điện' },
  { slug: 'xe-the-thao-dien', label: 'Xe thể thao điện' },
  { slug: 'phu-kien', label: 'Phụ kiện xe điện' },
  { slug: 'pin-sac', label: 'Pin & Sạc điện' },
  { slug: 'do-bao-ho', label: 'Đồ bảo hộ' },
]

export const BRANDS = ['VinFast', 'Yadea', 'DK Bike', 'Pega', 'Honda', 'Dibao', 'Osakar']

export const PRICE_RANGES: PriceRange[] = [
  { min: 0,         max: 10_000_000, label: 'Dưới 10 triệu' },
  { min: 10_000_000, max: 15_000_000, label: '10 — 15 triệu' },
  { min: 15_000_000, max: 20_000_000, label: '15 — 20 triệu' },
  { min: 20_000_000, max: 30_000_000, label: '20 — 30 triệu' },
  { min: 30_000_000, max: 999_000_000, label: 'Trên 30 triệu' },
]

export const SORT_OPTIONS: { value: SortOption; label: string }[] = [
  { value: 'popular',    label: 'Phổ biến' },
  { value: 'newest',     label: 'Mới nhất' },
  { value: 'price-asc',  label: 'Giá tăng dần' },
  { value: 'price-desc', label: 'Giá giảm dần' },
  { value: 'discount',   label: 'Giảm giá nhiều' },
]

export const PAGE_SIZE = 12
